export default (state) => state.restricted._session.hasDisconnectedAtLeastOnce;
